import { bind, play, setVolume } from 'cuelume';

const VOLUME = 0.65;

export function initCuelume() {
  if (typeof document === 'undefined') return;
  bind();
  setVolume(VOLUME);
}

export function playCue(name, options) {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
    return;
  }
  play(name, options);
}
